import React from 'react';
import i18n from 'util/i18n';

interface AttachmentListData {
  id: number
  description: string
  filename: string
  size: number
  uploadTime: string
}

interface AttachmentListProps {
  data: AttachmentListData[]
  fetchAttachment: (id: number, filename: string) => void
}

const AttachmentList: React.FC<AttachmentListProps> = ({ data, fetchAttachment }) => (
  <div className="list">
    {data.map((item) => (
      <div key={item.id}>
        <button
          className="usa-button"
          type="button"
          onClick={() => fetchAttachment(item.id, item.filename)}
          title={i18n.t('login.locked.certificates.buttonText')}
        >
          {i18n.t('login.locked.certificates.buttonText')}
        </button>
        {item.filename} {item.uploadTime}
      </div>
    ))}
  </div>
);

export default AttachmentList;
